import String from '../../../assets/Locales/teacher_locales.js';
// String.setLanguage(localStorage.getItem("Language"));
let lang = localStorage.getItem("Language");
//console.log(("lang",lang)
if (lang) {
    //console.log(("lang in if",lang)
    String.setLanguage(localStorage.getItem("Language"));
} else {
    //console.log(("lang in else",lang)
    lang = "ar"
    String.setLanguage("ar");
}
export const Inputs = [
    [

        {
            type: "select",
            name: "type",
            label: { ar: "اختر النوع", en: "Choose type" },
            title: { ar: "", en: "" },
            optionTitle: { ar: "النوع", en: "Type" },
            options: [
                { value: "TEACHER", title: { ar: "مدرس", en: "Teacher" } },
                { value: "ASSISTANT", title: { ar: "مساعد", en: "Assistant" } },
                { value: "STUDENT", title: { ar: "طالب", en: "Student" } },
                { value: "GUARDIAN", title: { ar: "ولي امر", en: "Parent" } },
            ],

        },
        {
            type: "text",
            name: "email",
            title: { ar: "", en: "" },
            label: { ar: "البريد الالكتروني او اسم المستخدم", en: "Email or user name" },
            placeholder: "NewConcept@gmail.com or NewConcept95",
        },
        {
            type: "password",
            label: { ar: "كلمة المرور", en: "Password" },
            placeholder: "**********",
            title: { ar: "", en: "" },
            name: "password",
        }
    ]

];


export const VisitorInput = [
    [
        {
            type: "select",
            name: "type",
            label: { ar: "اسم المرحلة", en: "Level's Name" },
            title: { ar: "", en: "" },
            optionTitle: { ar: "", en: "" },
            options: [
                { value: "TEACHER", title: { ar: "مدرس", en: "Teacher" } },
                { value: "ASSISTANT", title: { ar: "مساعد", en: "Assistant" } },
                { value: "STUDENT", title: { ar: "طالب", en: "Student" } },
                { value: "GUARDIAN", title: { ar: "ولي امر", en: "Parent" } },
            ],

        },
        {
            type: "select",
            name: "type",
            label: { ar: "اسم الصف", en: "Class's Name" },
            title: { ar: "", en: "" },
            optionTitle: { ar: "", en: "" },
            options: [
                { value: "TEACHER", title: { ar: "مدرس", en: "Teacher" } },
                { value: "ASSISTANT", title: { ar: "مساعد", en: "Assistant" } },
                { value: "STUDENT", title: { ar: "طالب", en: "Student" } },
                { value: "GUARDIAN", title: { ar: "ولي امر", en: "Parent" } },
            ],

        },
    ]
];
